import React from 'react';
export default function CookieYesToggle() {
    return (React.createElement("button", { type: "button", className: "cky-banner-element small" }, "Manage cookies"));
}
